import { createSlice } from '@reduxjs/toolkit';

import type { UserProfileRead } from 'src/common/external/bambi-api/bambiApi';
import { getStorageValue } from 'src/common/util/useLocalStorage/getStorageValue';

// TODO: Probably should isolate this per user id
export const currentOrgStorageKey = 'current-organization-id';

export interface IAuthState {
  profile?: UserProfileRead | null;
  currentOrganizationId?: string;
  isOrganizationChangeOpen: boolean;
}

export const initialState: IAuthState = {
  profile: null,
  // Restore the last-selected org on load; signIn re-validates it against the
  // profile's memberships. Writing back to storage is owned by
  // organizationPersistence.listener so these reducers stay pure.
  // Guarded for non-DOM envs (the node Vitest project has no localStorage),
  // since this slice is imported at module load across the app.
  currentOrganizationId:
    typeof localStorage === 'undefined'
      ? undefined
      : getStorageValue<string>(currentOrgStorageKey, '') || undefined,
  isOrganizationChangeOpen: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.profile = action.payload;
      const memberships = state.profile?.memberships ?? [];
      // Keep the current selection if the user still has access to it,
      // otherwise fall back to their first membership (undefined if none).
      const preferred =
        state.currentOrganizationId ?? memberships[0]?.organization.id;
      const hasAccess = memberships.some(
        (membership) => membership.organization.id === preferred
      );
      state.currentOrganizationId = hasAccess
        ? preferred
        : memberships[0]?.organization.id;
    },
    changeOrganization: (state, action) => {
      state.currentOrganizationId = action.payload;
    },
    setIsOrganizationChangeOpen: (state, action) => {
      state.isOrganizationChangeOpen = action.payload;
    },
  },
});
